import { getAnalytics, logEvent as logFirebaseEvent } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'

import { envConfig } from '@twisto/base/env-config'

import type { AnalyticsService, EventParameters } from '../analytics-service'
import type { AnalyticsEventName } from '../events'

const initializeFirebaseAnalyticsApp = () => {
  if (typeof window === 'undefined') {
    return null
  }

  const { FIREBASE_CONFIG } = envConfig
  if (!FIREBASE_CONFIG) {
    return null
  }

  const app = initializeApp(FIREBASE_CONFIG)

  return getAnalytics(app)
}

const firebaseAnalytics = initializeFirebaseAnalyticsApp()

const logEvent = (name: AnalyticsEventName, parameters: EventParameters) => {
  if (firebaseAnalytics) {
    logFirebaseEvent(firebaseAnalytics, name as string, { ...parameters })
  }
}

export class FirebaseAnalyticsService implements AnalyticsService {
  logEvent(name: AnalyticsEventName, parameters: EventParameters) {
    logEvent(name, parameters)
  }
}
